export default __webpack_public_path__ + "static/media/checker.08c103f5.png";